//식단표 이미지 만들기 - 정적 이미지 경로 (public/img/mealplan, 목업 data URI 에서 추출)
//음식 이름(한글) 순서 = 썸네일 음식 선택창 순서. 서버 router/mealPlanImage.ts EMOJI_NAMES 와 같아야 함

const BASE = "img/mealplan/";

export const LOGO_SRC = BASE + "logo.svg";
export const PLATE_SRC = BASE + "plate.webp";

const FOOD_FILES: [string, string][] = [
    ["볶음밥", "bokkeumbap"], ["제육덮밥", "jeyukdeopbap"], ["비빔밥", "bibimbap"], ["카레라이스", "curryrice"],
    ["오므라이스", "omurice"], ["짜장밥", "jjajangbap"], ["김밥", "gimbap"], ["주먹밥", "jumeokbap"],
    ["초밥", "sushi"], ["떡볶이", "tteokbokki"], ["돈까스", "donkatsu"], ["함박스테이크", "hambak"],
    ["깐풍기", "kkanpunggi"], ["치킨", "chicken"], ["삼겹살", "samgyeopsal"], ["새우튀김", "shrimptempura"],
    ["만두", "mandu"], ["국밥", "gukbap"], ["짬뽕", "jjamppong"], ["우동", "udon"],
    ["냉면", "naengmyeon"], ["쌀국수", "pho"], ["파스타", "pasta"], ["피자", "pizza"],
    ["버거", "burger"], ["샌드위치", "sandwich"], ["타코", "taco"], ["샐러드", "salad"]
];

export const FOOD_NAMES: string[] = FOOD_FILES.map((e) => e[0]);

export const FOOD_SRC: { [name: string]: string } = {};
FOOD_FILES.forEach(([name, file]) => { FOOD_SRC[name] = `${BASE}food/${file}.webp`; });

//Pretendard (public/fonts) — 이미지 글꼴을 목업과 같게. 이 화면에서만 FontFace 로 등록
const FONT_FILES: [string, string][] = [["500", "fonts/Pretendard-Medium.woff2"], ["700", "fonts/Pretendard-Bold.woff2"]];

let fontPromise: Promise<void> | null = null;
export const loadPretendard = (): Promise<void> => {
    if (!fontPromise) {
        fontPromise = Promise.all(FONT_FILES.map(async ([weight, url]) => {
            try {
                const face = new (window as any).FontFace("Pretendard", `url(${url})`, { weight });
                await face.load();
                (document as any).fonts.add(face);
            } catch (e) {
                //못 불러오면 기기 기본 글꼴로 그림
                console.log(e);
            }
        })).then(() => undefined);
    }
    return fontPromise;
};
